import { useEffect, useRef } from "react";
import type { NextPrayer } from "@/types/prayer";

export function useNotifications(
  enabled: boolean,
  nextPrayer: NextPrayer | null
) {
  const firedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled || !nextPrayer || nextPrayer.name === "Sunrise") return;

    const tag = `${nextPrayer.name}-${nextPrayer.time.getTime()}`;

    // Don't fire the same notification twice
    if (firedRef.current === tag) return;

    const ms = nextPrayer.time.getTime() - Date.now();
    if (ms < -60_000) return; // more than a minute in the past, skip

    const fire = () => {
      if (Notification.permission !== "granted") return;
      firedRef.current = tag;
      navigator.serviceWorker.ready.then((reg) => {
        reg.showNotification("Miqat", {
          body: `It's time for ${nextPrayer.name}`,
          icon: "/icons/icon-192.png",
          tag: nextPrayer.name,
        });
      });
    };

    if (ms <= 0) {
      fire();
      return;
    }

    const timeout = setTimeout(fire, ms);
    return () => clearTimeout(timeout);
  }, [enabled, nextPrayer]);
}
